import { render, staticRenderFns } from "./shrinkable-menu.vue?vue&type=template&id=a5402acc&"
import script from "./shrinkable-menu.vue?vue&type=script&lang=ts&"
export * from "./shrinkable-menu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "shrinkable-menu.vue"
export default component.exports